module.exports = __webpack_public_path__ + "492e9e35ddff9c1847b68f64141c99e7.png";